<template>
  <div>
    <!-- Drawer抽屉 -->
    <Drawer :title="title" v-model="visible" width="720" draggable>
      <div :style="{maxHeight: maxHeight}" class="drawer-content">
        <Form ref="form" :model="form" :rules="formValidate" label-position="top">
          <div class="drawer-header">
            <div style="margin-right: 16px">基本信息</div>
          </div>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="设备名称" prop="deviceName">
                <Input v-model="form.deviceName" clearable/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="过期时间" prop="expireTime">
                <DatePicker type="datetime" v-model="form.expireTime" clearable transfer style="width: 100%"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <div class="drawer-header">
            <div style="margin-right: 16px">联系信息</div>
          </div>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="联系人名字" prop="contactName">
                <Input v-model="form.contactName" clearable/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="联系人电话" prop="contactPhone">
                <Input v-model="form.contactPhone" clearable/>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="联系人email" prop="email">
                <Input v-model="form.email" clearable/>
              </FormItem>
            </Col>
          </Row>
          <div class="drawer-header">
            <div style="margin-right: 16px">关联信息</div>
          </div>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="数据服务商" prop="vendorId">
                <Select v-model="form.vendorId" filterable :clearable="true" :label-in-value="true" @on-select="vendorChange" @on-change="vendorChange">
                  <Option v-for="item in vendorList" :value="item.id" :key="item.id">{{ item.orgName }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="制造厂商" prop="realVendorDisplay">
                <Input v-model="form.realVendorDisplay" clearable/>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="物理位置" prop="physicalPositionOrgId">
                <Select v-model="form.physicalPositionOrgId" filterable :label-in-value="true" @on-change="parkChange">
                  <Option v-for="item in parkList" :value="item.id" :key="item.id">{{ item.orgName }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="是否有采集模块" prop="hasCollectModel">
               
                <Select v-model="form.hasCollectModel" transfer>
                  <Option value="是">是</Option>
                  <Option value="否">否</Option>
                </Select>           
              </FormItem>
            </Col>
          </Row>
          <div style="height:200px">
          </div>
          
          <!-- <div class="drawer-header">
            <div style="margin-right: 16px">设备信息</div>
          </div>
          
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="在线状态监控点" prop="onLinePoint">
                <Input v-model="form.onLinePoint" clearable/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="连接字符串" prop="conectStr">
                <Input v-model="form.conectStr" clearable/>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="设备型号" prop="deviceModel">
                <Input v-model="form.deviceModel" clearable/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="设备类型" prop="deviceType">
                <Input v-model="form.deviceType" clearable/>
              </FormItem>
            </Col>
          </Row> -->
          <!-- <Row :gutter="32">
            <Col span="12">
              <FormItem label="设备级别" prop="deviceLevel">
                <Input v-model="form.deviceLevel" clearable/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="plc型号" prop="plcModel">
                <Input v-model="form.plcModel" clearable/>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="非开关变量的采集周期(毫秒)" prop="collectTime">
                <InputNumber v-model="form.collectTime" style="width:100%"></InputNumber>
              </FormItem>
            </Col>

          </Row> -->
          <!-- <div class="drawer-header">
            <div style="margin-right: 16px">资质信息</div>
          </div>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="操作人员资质" prop="operateQualification">
                <Input v-model="form.operateQualification" clearable/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="安全责任人资质" prop="safeQualification">
                <Input v-model="form.safeQualification" clearable/>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="维护人员资质" prop="maintainQualification">
                <Input v-model="form.maintainQualification" clearable/>
              </FormItem>
            </Col>

          </Row> -->
          <!-- <div class="drawer-header">
            <div style="margin-right: 16px">其他信息</div>
          </div>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="上次年检时间" prop="lastYearCheckTime">
                <DatePicker type="datetime" v-model="form.lastYearCheckTime" clearable transfer
                            style="width: 100%"></DatePicker>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="提前通知天数" prop="preNoticeDays">
                <InputNumber v-model="form.preNoticeDays" style="width:100%"></InputNumber>
              </FormItem>
            </Col>
          </Row> -->

        </Form>
      </div>
      <div class="drawer-footer br" v-show="type!='0'">
        <Button type="primary" :loading="submitLoading" @click="submit">提交</Button>
        <Button @click="visible = false">取消</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
// import dict from "@/views/my-components/jmbase/dict";

let dict  = window.jinmabasecomponents.components.dict;
import {
  validateUsername,
  validateMobile,
  validatePassword,
} from "@/libs/validate";
import { getOrgList, addDevice, editDevice } from "@/api/index"

export default {
  name: "addEdit",
  components: {
    dict,
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    },
    type: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      vendorList: [],
      parkList: [],
      visible: this.value,
      title: "",
      submitLoading: false,
      maxHeight: 510,
      form: { // 添加或编辑表单对象初始化数据
        deviceName: "",
        expireTime: "",
        contactName: "",
        contactPhone: "",
        email: "",
        vendorId: "",
        vendorName: "",
        physicalPositionOrgId: "",
        physicalPositionOrgName: "",
        hasCollectModel: "",
        status: 1,
        deviceModel: "",
        deviceType: "",
        deviceLevel: "",
        plcModel: "",
        collectTime: 0,
        conectStr: "",
        onLinePoint: "",
        operateQualification: "",
        maintainQualification: "",
        safeQualification: "",
        lastYearCheckTime: "",
        preNoticeDays: 0,      
        realVendorDisplay: "",
        contactName: "",
        contactPhone: "",
      },
      // 表单验证规则
      formValidate: {
        vendorId: [{required: true, message: "不能为空", trigger: "change"}],
        physicalPositionOrgId: [{required: true, message: "不能为空", trigger: "change"}],        
        deviceName: [{required: true, message: "不能为空", trigger: "change"}],
        realVendorDisplay: [{required: true, message: "不能为空", trigger: "change"}],         
        hasCollectModel: [{required: true, message: "不能为空", trigger: "change"}],         
        expireTime: [{required: true, message: "不能为空", trigger: "change", pattern: /.+/}],
        email: [
          { required: true, message: "请输入邮箱地址" },
          { type: "email", message: "邮箱格式不正确" },
        ],    
        contactName: [{required: true, message: "不能为空", trigger: "change"}],        
        contactPhone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "change",
          },
          {
            validator: validateMobile,
            trigger: "change",
          },
        ],
      }
    };
  },
  methods: {
    vendorChange(vendor) {
      if(vendor){
      this.form.vendorId = vendor.value
      this.form.vendorName = vendor.label
    }
    },
    parkChange(park) {
	if(park){
      this.form.physicalPositionOrgId = park.value
      this.form.physicalPositionOrgName = park.label
	 }
    },
    init() {
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          console.log(this.form)
          if (typeof this.form.expireTime == "object") {
            this.form.expireTime = this.format(this.form.expireTime, "yyyy-MM-dd HH:mm:ss");
          }
          if (typeof this.form.lastYearCheckTime == "object") {
            this.form.lastYearCheckTime = this.format(this.form.lastYearCheckTime, "yyyy-MM-dd HH:mm:ss");
          }
          if (this.form.id === null) {
            addDevice(this.form).then(res => {
              this.submitLoading = false;
              if (res.success) {
                this.$Message.success("操作成功");
                this.$emit("on-submit", true);
                this.visible = false;
              }
            });
          } else {
            editDevice(this.form).then(res => {
              this.submitLoading = false;
              if (res.success) {
                this.$Message.success("操作成功");
                this.$emit("on-submit", true);
                this.visible = false;
              }
            });
          }
        }
      });
    },
    setCurrentValue(value) {
      if (value === this.visible) {
        return;
      }
      if (this.type == "1") {
        this.title = "编辑";
        this.maxHeight =
            Number(document.documentElement.clientHeight - 121) + "px";
      } else if (this.type == "2") {
        this.title = "添加";
        this.maxHeight =
            Number(document.documentElement.clientHeight - 121) + "px";
      } else {
        this.title = "详细信息";
        this.maxHeight = "100%";
      }
      // 清空数据
      this.$refs.form.resetFields();
      if (this.type == "0" || this.type == "1") {
        // 回显数据处理
        this.form = this.data;
      } else {
        // 添加
        delete this.form.id;
      }
      this.visible = value;

      let searchParam = {
        pageNumber: 1,
        pageSize: 100,
        organizationType: 108
      }
      getOrgList(searchParam).then(res => {
        if (res.success) {
          this.vendorList = res.result.records
        }
      })
      let searchParam2 = {
        pageNumber: 1,
        pageSize: 3000
      }
      getOrgList(searchParam2).then(res => {
        if (res.success) {
          this.parkList = res.result.records
        }
      })
    }
  },
  watch: {
    value(val) {
      this.setCurrentValue(val);
    },
    visible(value) {
      this.$emit("input", value);
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="less">
// 建议引入通用样式 具体路径自行修改 可删除下面样式代码
// @import "@/styles/drawer-common.less";
.drawer-footer {
  z-index: 10;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: left;
  background: #fff;
}

.drawer-content {
  overflow: auto;
}

.drawer-content::-webkit-scrollbar {
  display: none;
}

.drawer-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
}

.drawer-title {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  display: block;
  margin-bottom: 16px;
}
</style>
